import styled from "styled-components";
import HelpCenterHeader from "./HelpCenterHeader";
import { DataSetIcon, MailIcon, SearchIcon } from "@dataone/icons";
import { scrollBarStyles } from "@dataone/lib";

export interface IHelpCard {
  Title: string;
  icon: JSX.Element;
  subtitles: IArticle[];
  path: string;
}
export interface IArticle {
  title: string;
  path?: string;
  isProductTour?: boolean;
  content?: JSX.Element;
}
const StyledTrelloArticle = styled.div`
  padding: 5px 10px;
`;
const BodyContent = styled.div`
  padding: 23px;
  font-size: 16px;
  overflow: auto;
  padding: 23px;
  height: calc(100vh - 275px);
  ${scrollBarStyles}
`;
const ArticleFooter = styled.div`
  padding: 44px;
  font-size: 16px;
`;
const StyledList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const StyledLink = styled.a`
  text-decoration: underline;
  font-size: 16px;
  margin-left: 10px;
`;
const Title = styled.h1`
  padding: 15px 46px;
  color: #4974f6;
`;
const StyledImageConatiner = styled.div`
  img {
    width: 400px;
  }
`;
export const HelpCardContent: IHelpCard[] = [
  // {
  //   Title: "Managing Account",
  //   path: "/support/managing-account",
  //   icon: (
  //     <img
  //       src="/images/support/support-cards-icons/manage-account.svg"
  //       alt=""
  //     />
  //   ),
  //   subtitles: [
  //     { title: "How to update your email address" },
  //     { title: "Help with logging in" },
  //     { title: "How to customize your profile" },
  //   ],
  // },
  // {
  //   Title: "Safety and security",
  //   icon: <img src="/images/support/support-cards-icons/security.svg" alt="" />,
  //   path: "/support/safety-and-security",
  //   subtitles: [
  //     { title: "How to protect and unprotect your Data" },
  //     { title: "About feedback for businesses" },
  //     { title: "About your email and phone number privacy" },
  //   ],
  // },
  {
    Title: "Data Connectors",
    icon: <DataSetIcon />,
    path: "/support/data-connectors",
    subtitles: [
      {
        title: "How to add Trello as your data source ",
        path: "/support/data-connectors/trello",
        content: (
          <StyledTrelloArticle>
            <HelpCenterHeader
              secondTitle="Data connectors"
              thirdTitle="Add Trello as data source"
            />
            <Title>How to add Trello as your data source</Title>
            <BodyContent>
              <StyledList>
                <li>
                  Click on the link :
                  <StyledLink
                    target="_blank"
                    href="https://trello.com/power-ups/admin"
                  >
                    https://trello.com/power-ups/admin
                  </StyledLink>
                </li>
                <img
                  src="images/support/data-connectors-41.webp"
                  alt="data-connectors-41"
                  width={800}
                />
                <li>
                  Click on the <b>"New" </b> button and fill in the fields :
                </li>
                <img
                  src="images/support/data-connectors-42.webp"
                  alt="data-connectors-42"
                  width={700}
                />
                <p>
                  Click on <b>Create</b>.
                </p>
                <li>
                  Click on <b>Generate a new API key</b>.
                </li>
                <img
                  src="images/support/data-connectors-43.webp"
                  alt="data-connectors-43"
                  width={800}
                />
                <p>
                  Click on <b>Generate API key</b>
                </p>
                <img
                  src="images/support/data-connectors-45.webp"
                  alt="data-connectors-45"
                  width={700}
                />
                <li>
                  Click on <b>"API key"</b> and then copy the API key.
                </li>
                <img
                  src="images/support/data-connectors-46.webp"
                  alt="data-connectors-46"
                  width={800}
                />
                <li>
                  Click on <b> "Token"</b>.
                </li>
                <img
                  src="images/support/data-connectors-44.webp"
                  alt="data-connectors-44"
                  width={800}
                />
                <li>
                  Scroll to the bottom of the page and click on <b>"Allow"</b>.
                </li>
                <img
                  src="images/support/data-connectors-47.webp"
                  alt="data-connectors-47"
                  width={600}
                />
                <li>
                  <b>Copy</b> the API token.
                </li>
                <img
                  src="images/support/data-connectors-48.webp"
                  alt="data-connectors-48"
                  width={800}
                />
                <li>
                  On the OneGate platform, click on <b>"Data center"</b>, then
                  select <b>"Create new data source”</b>.
                </li>
                <img
                  src="images/support/data-connectors-37.webp"
                  alt="data-connectors-37"
                  width={800}
                />
                <li>
                  Navigate to the <b>“Enterprise connector”</b> and select
                  <b> “Trello”</b> as the new data source.
                </li>
                <img
                  src="images/support/data-connectors-38.webp"
                  alt="data-connectors-38"
                  width={700}
                />
                <li>
                  Enter the <b>display name</b> of your choice, then paste the
                  <b> API token</b> and <b>API key</b> into the designated
                  fields
                </li>
                <img
                  src="images/support/data-connectors-50.webp"
                  alt="data-connectors-50"
                  width={700}
                />
                <li>
                  The <b>integration ID</b> can be found here. Copy it and paste
                  it into the specified blank <b>(field : integration )</b>.
                </li>
                <img
                  src="images/support/data-connectors-51.webp"
                  alt="data-connectors-51"
                  width={800}
                />
                <li>
                  Your data source has been successfully created. Now, click on{" "}
                  <b>"Done."</b>
                </li>
                <img
                  src="images/support/data-connectors-17.webp"
                  alt="data-connectors-17"
                  width={800}
                />
              </StyledList>
            </BodyContent>
            {/* <ArticleFooter>
              Official guide link:
              <StyledLink target="_blank" href="https://developer.atlassian.com/cloud/trello/guides/rest-api/api-introduction/">
                https://developer.atlassian.com/cloud/trello/guides/rest-api/api-introduction/
              </StyledLink>
            </ArticleFooter> */}
          </StyledTrelloArticle>
        ),
      },
      {
        title: "How to add Jira as your Data Source",
        path: "/support/data-connectors/jira",
        content: (
          <StyledTrelloArticle>
            <HelpCenterHeader
              secondTitle="Data Connectors"
              thirdTitle="Add Jira as data source"
            />
            <Title>How to add Jira as your Data Source</Title>
            <BodyContent>
              <StyledList>
                {/* <li>
                  Go to
                  <StyledLink target="_blank" href="https://id.atlassian.com/manage-profile/security/api-tokens">
                    https://id.atlassian.com/manage-profile/security/api-tokens
                  </StyledLink>
                </li> */}
                <li>
                  Click on the provided link, then click on{" "}
                  <b>"Create API token"</b>.
                  <StyledLink
                    target="_blank"
                    href="https://id.atlassian.com/manage-profile/security/api-tokens"
                  >
                    https://id.atlassian.com/manage-profile/security/api-tokens
                  </StyledLink>
                </li>
                <img
                  src="images/support/data-connectors-34.webp"
                  alt="data-connectors-34"
                  width={800}
                />
                <li>
                  Generate an API token and then click on <b>"Create"</b>.
                </li>
                <img
                  src="images/support/data-connectors-35.webp"
                  alt="data-connectors-35"
                  width={800}
                />
                <li>
                  Click on <b>"Copy"</b> to copy the API token.
                </li>
                <img
                  src="images/support/data-connectors-36.webp"
                  alt="data-connectors-36"
                  width={800}
                />
                <li>
                  Click on <b>"Data center"</b>, then select{" "}
                  <b>"Create new data source"</b>, + link
                </li>
                <img
                  src="images/support/data-connectors-37.webp"
                  alt="data-connectors-37"
                  width={800}
                />
                <li>
                  Navigate to the <b> "Enterprise connector"</b> and select{" "}
                  <b>"Jira"</b>as the new data source.
                </li>
                <img
                  src="images/support/data-connectors-38.webp"
                  alt="data-connectors-38"
                  width={650}
                />
                <li>
                  Fill in the fields as the following :
                  <dd>
                    <b> - Display name </b>
                  </dd>
                  <dd>
                    <b> - API Token</b> : already copied
                  </dd>
                  <dd>
                    <b> - Email </b> : client email
                  </dd>
                  <dd>
                    <b> - Workspace link </b> : domain name in the browser
                    search bar
                  </dd>
                  <dd>
                    <b> - Integration </b> : name of project
                  </dd>
                  and click <b>Create</b> .
                </li>
                <img
                  src="images/support/data-connectors-39.webp"
                  alt="data-connectors-39"
                  width={650}
                />
                <li>
                  Your data source has been successfully created. Now, click on{" "}
                  <b>"Done"</b>.
                </li>
                <img
                  src="images/support/data-connectors-17.webp"
                  alt="data-connectors-17"
                  width={800}
                />
              </StyledList>
            </BodyContent>
            {/* <ArticleFooter>
              Official guide link:
              <StyledLink target="_blank" href="https://support.atlassian.com/atlassian-account/docs/manage-api-tokens-for-your-atlassian-account/">
                https://support.atlassian.com/atlassian-account/docs/manage-api-tokens-for-your-atlassian-account/
              </StyledLink>
            </ArticleFooter> */}
          </StyledTrelloArticle>
        ),
      },
      {
        title: "How to add Slack as your Data Source",
        path: "/support/data-connectors/slack",
        content: (
          <StyledTrelloArticle>
            <HelpCenterHeader
              secondTitle="Data Connectors"
              thirdTitle="Add Slack as data source"
            />
            <Title>How to add Slack as your Data Source</Title>
            <BodyContent>
              <StyledList>
                <li>
                  Head to this URL :
                  <StyledLink
                    target="_blank"
                    href="https://api.slack.com/tutorials/tracks/getting-a-token"
                  >
                    https://api.slack.com/tutorials/tracks/getting-a-token
                  </StyledLink>
                </li>
                <img
                  src="images/support/data-connectors-18.webp"
                  alt="data-connectors-18"
                  width={800}
                />
                <li>
                  Press on <b>Create App</b>.
                </li>
                <img
                  src="images/support/data-connectors-19.webp"
                  alt="data-connectors-19"
                  width={800}
                />
                <li>If you don’t have a workspace, create your own.</li>
                <img
                  src="images/support/data-connectors-20.webp"
                  alt="data-connectors-20"
                  width={800}
                />
                <img
                  src="images/support/data-connectors-21.webp"
                  alt="data-connectors-21"
                  width={800}
                />
                <li>
                  Open the drop-down menu, Select the <b>Workspace</b> then
                  Press <b>Next</b>
                </li>
                <img
                  src="images/support/data-connectors-22.webp"
                  alt="data-connectors-22"
                  width={450}
                />
                <li>
                  Open the <b>Settings </b> tab and click on{" "}
                  <b>Edit Configurations.</b>
                </li>
                <img
                  src="images/support/data-connectors-23.webp"
                  alt="data-connectors-23"
                  width={450}
                />
                <li>Copy the configuration below :</li>
                <img
                  src="images/support/data-connectors-24.webp"
                  alt="data-connectors-24"
                  width={400}
                />
                <li>
                  Click on <b>Create.</b>
                </li>
                <img
                  src="images/support/data-connectors-25.webp"
                  alt="data-connectors-25"
                  width={400}
                />
                <li>The workspace is created successfully.</li>
                <img
                  src="images/support/data-connectors-26.webp"
                  alt="data-connectors-26"
                  width={500}
                />
                <li>
                  Go to <b>Install App</b> in the side bar.
                </li>
                <img
                  src="images/support/data-connectors-27.webp"
                  alt="data-connectors-27"
                  width={800}
                />
                <li>
                  Grant access permission by clicking on <b>Allow.</b>
                </li>
                <img
                  src="images/support/data-connectors-28.webp"
                  alt="data-connectors-28"
                  width={500}
                />
                <li>
                  Navigate to the <b>`OAuth & Permissions`</b>tab and locate the{" "}
                  <b>`Bot user OAuth Token`</b> within the{" "}
                  <b>`OAuth Tokens for your workspace`</b> section and then copy
                  the token.
                </li>
                <img
                  src="images/support/data-connectors-29.webp"
                  alt="data-connectors-29"
                  width={550}
                />
                <li>
                  Go to your Slack workspace and copy the channel ID from the
                  URL.
                </li>
                <img
                  src="images/support/data-connectors-30.webp"
                  alt="data-connectors-30"
                  width={800}
                />
                <li>
                  Fill in the Fields and click on <b>Create.</b>
                  <br />
                  <>
                    {" "}
                    <img
                      src="images/support/data-connectors-31.webp"
                      alt="data-connectors-31"
                      width={650}
                    />
                  </>
                  <dd>
                    {" "}
                    <u>N.B:</u> You can add one more Integration Id.
                  </dd>
                  <dd>The Channel ID (Integration) can be found here:</dd>
                  <img
                    src="images/support/data-connectors-32.webp"
                    alt="data-connectors-32"
                    width={650}
                  />
                </li>
                <li>Your data source is successfully created.</li>
                <img
                  src="images/support/data-connectors-17.webp"
                  alt="data-connectors-17"
                  width={800}
                />
                <li>
                  {" "}
                  As <b>the final step</b>, the user must invite the bot into a
                  specific channel to enable interaction with its content.
                </li>
              </StyledList>
            </BodyContent>
            {/* <ArticleFooter>
              Official guide link:
              <StyledLink target="_blank" href="https://api.slack.com/tutorials/tracks/getting-a-token">
                https://api.slack.com/tutorials/tracks/getting-a-token
              </StyledLink>
            </ArticleFooter> */}
          </StyledTrelloArticle>
        ),
      },
      {
        title: "How to add Google Drive  as your Data Source",
        path: "/support/data-connectors/google-drive",
        content: (
          <StyledTrelloArticle>
            <HelpCenterHeader
              secondTitle="Data Connectors"
              thirdTitle="Add Google Drive as data source"
            />
            <Title>How to add Google Drive as your Data Source</Title>
            <BodyContent>
              <StyledList>
                <li>
                  Visit the following link :
                  <StyledLink
                    target="_blank"
                    href="https://cloud.google.com/iam/docs/keys-create-delete"
                  >
                    https://cloud.google.com/iam/docs/keys-create-delete
                  </StyledLink>
                </li>
                <img
                  src="images/support/data-connectors-1.webp"
                  alt="data-connectors-1"
                  width={800}
                />
                <li>
                  Press on the button « <b>Enable API</b> » .
                </li>
                <img
                  src="images/support/data-connectors-2.webp"
                  alt="data-connectors-2"
                  width={220}
                />
                <li>
                  Scroll down and press <b>Go to Service accounts</b> .
                </li>
                <img
                  src="images/support/data-connectors-3.webp"
                  alt="data-connectors-3"
                  width={800}
                />
                <li>
                  Create a <b>new project</b> or select an existing one.
                </li>
                <div style={{ display: "inline-flex", gap: 20 }}>
                  <img
                    src="images/support/data-connectors-4.webp"
                    alt="data-connectors-4"
                    width={400}
                  />
                  <img
                    src="images/support/data-connectors-5.webp"
                    alt="data-connectors-5"
                    width={400}
                  />
                </div>
                <li>
                  Click on <b>CREATE A SERVICE ACCOUNT.</b>
                </li>
                <img
                  src="images/support/data-connectors-6.webp"
                  alt="data-connectors-6"
                  width={800}
                />
                <li>
                  Fill in the required fields, then click on{" "}
                  <b>CREATE AND CONTINUE.</b>
                </li>
                <img
                  src="images/support/data-connectors-7.webp"
                  alt="data-connectors-7"
                  width={300}
                />
                <li>
                  Select <b> Basic {"->"} Owner</b> role from the list then
                  click on <b>CONTINUE.</b>
                </li>
                <img
                  src="images/support/data-connectors-8.webp"
                  alt="data-connectors-8"
                  width={500}
                />
                <li>
                  Click on the “<b>OK</b>” button to grant access permissions.
                </li>
                <img
                  src="images/support/data-connectors-9.webp"
                  alt="data-connectors-9"
                  width={700}
                />
                <li>
                  Click on the <b>email </b> address of the service account you
                  want to create a key for.
                </li>
                <img
                  src="images/support/data-connectors-10.webp"
                  alt="data-connectors-10"
                  width={700}
                />
                <li>
                  Click the <b>Keys</b> tab.
                </li>
                <img
                  src="images/support/data-connectors-11.webp"
                  alt="data-connectors-11"
                  width={650}
                />
                <li>
                  Click the <b>Add a key</b> drop-down menu, then create a new
                  key or import an existing one.
                </li>
                <img
                  src="images/support/data-connectors-12.webp"
                  alt="data-connectors-12"
                  width={200}
                />
                <li>
                  Mark <b>JSON</b> option as the <b>Key type</b> and click on{" "}
                  <b>CREATE.</b>
                </li>
                <img
                  src="images/support/data-connectors-13.webp"
                  alt="data-connectors-13"
                  width={400}
                />
                <li>The key is successfully created.</li>
                <img
                  src="images/support/data-connectors-14.webp"
                  alt="data-connectors-14"
                  width={700}
                />
                <li>
                  Fill in the required fields:
                  <dd>
                    &#10004;
                    <b>
                      <i>Display name:</i>
                    </b>{" "}
                    a name given by the client to identicate the data source in
                    OneGate platform.
                  </dd>
                  <dd>
                    &#10004;
                    <b>
                      <i>Drive folder link:</i>
                    </b>{" "}
                    the link that appears in the browser while you’re in Google
                    Drive.
                  </dd>
                  <dd>
                    &#10004;
                    <b>
                      <i>Upload credentials:</i>
                    </b>{" "}
                    The previously downloaded file.
                  </dd>
                </li>
                <div
                  style={{
                    display: "inline-flex",
                    gap: 1,
                    alignItems: "center",
                  }}
                >
                  <img
                    src="images/support/data-connectors-15.webp"
                    alt="data-connectors-15"
                    width={580}
                  />
                  <img
                    src="images/support/data-connectors-16.webp"
                    alt="data-connectors-16"
                    width={500}
                    height={250}
                  />
                </div>
                <li>Your data source is now successfully created.</li>
                <img
                  src="images/support/data-connectors-17.webp"
                  alt="data-connectors-17"
                  width={800}
                />
              </StyledList>
            </BodyContent>
            {/* <ArticleFooter>
              Official guide link:
              <StyledLink target="_blank" href="https://cloud.google.com/iam/docs/keys-create-delete">
                https://cloud.google.com/iam/docs/keys-create-delete
              </StyledLink>
            </ArticleFooter> */}
          </StyledTrelloArticle>
        ),
      },
    ],
  },
  // {
  //   Title: "Using OneGata",
  //   icon: <img src="/images/support/support-cards-icons/usage.svg" alt="" />,
  //   path: "/support/using-onegate",
  //   subtitles: [
  //     { title: "Get Started" },
  //     { title: "Help with logging in" },
  //     { title: "How to customize your profile" },
  //   ],
  // },
  // {
  //   Title: "Rules and Policy",
  //   icon: <img src="/images/support/support-cards-icons/rules.svg" alt="" />,
  //   path: "/support/rules-and-policy",
  //   subtitles: [
  //     { title: "How we enforce our rules" },
  //     { title: "About feedback for businesses" },
  //     { title: "About your email and phone number privacy" },
  //   ],
  // },
  {
    Title: "Smart Search",
    icon: <SearchIcon />,
    path: "/support/smart-search",
    subtitles: [
      {
        title: "Get started with smart search",
        path: "/dashboard",
        isProductTour: true,
      },
      // { title: "How to add Jira" },
      // { title: "How to add Slack" },
    ],
  },
  // {
  //   Title: "Safety and security",
  //   icon: <img src="/images/support/support-cards-icons/security.svg" alt="" />,
  //   path: "/support/safety-and-security",
  //   subtitles: [
  //     { title: "How to protect and unprotect your Data" },
  //     { title: "About feedback for businesses" },
  //     { title: "About your email and phone number privacy" },
  //   ],
  // },
  // {
  //   Title: "Managing Account",
  //   path: "/support/managing-account",
  //   icon: (
  //     <img
  //       src="/images/support/support-cards-icons/manage-account.svg"
  //       alt=""
  //     />
  //   ),
  //   subtitles: [
  //     { title: "How to update your email address" },
  //     { title: "Help with logging in" },
  //     { title: "How to customize your profile" },
  //   ],
  // },
  {
    Title: "Contact OneGate Support",
    path: "/support/contact-us",
    icon: <MailIcon />,
    subtitles: [],
  },
];
